import { matchPath } from 'react-router';
import { Routes } from './Routes';

/** The PWA manifest's `start_url`, which renders the homepage. */
export const PWA_START_PATH = '/index.html';

const APP_PATHS = [...Object.values(Routes).filter((route) => route.startsWith('/')), PWA_START_PATH];

/**
 * Whether a path is one the app has a route for. The server answers these with the app and a 200 and
 * everything else with a 404, and `ConsumerRouter` renders the not-found page for everything else, so
 * both must use this one matcher. `path-to-regexp` on the server and `matchPath` here disagree at the
 * edges: the server alone treats `//` as `/`.
 */
export const isAppPath = (pathname: string): boolean =>
  APP_PATHS.some((path) => !!matchPath(pathname, { path, exact: true }));
